import { latLngEquals } from '@/lib/latlng'
import type { LatLng } from '@/types/structs'
import type { DirectionFor, BottomSheetView } from '@/types/enums'

/* The didUpdateWidget dispatch table (custom_g_map.dart:76-128) as a PURE
 * function so the mutually-exclusive branch order is unit-testable.
 *
 *   IF view == directions:
 *     (a) destination changed OR directionFor changed -> 'updateRoute'
 *         (NOTE: _currentLocation NOT synced — stale-origin quirk kept)
 *     (b) else if just entered directions             -> 'enterDirections'
 *     (c) else if currentLocation changed             -> 'locationTick'
 *   ELSE:
 *     destination changed OR view changed             -> 'rebuildAndPan'
 *
 * LatLng comparisons are STRUCTURAL (Dart operator==). */

export interface MapSnap {
  destination: LatLng
  directionFor: DirectionFor
  bottomSheetView: BottomSheetView
  currentLocation: LatLng | null
}

export type MapDispatch =
  | 'updateRoute' // (a)
  | 'enterDirections' // (b)
  | 'locationTick' // (c)
  | 'rebuildAndPan' // ELSE
  | 'none'

export function dispatchMapUpdate(prev: MapSnap, next: MapSnap): MapDispatch {
  if (next.bottomSheetView === 'directions') {
    if (
      !latLngEquals(prev.destination, next.destination) ||
      prev.directionFor !== next.directionFor
    ) {
      return 'updateRoute'
    }
    if (prev.bottomSheetView !== 'directions') {
      return 'enterDirections'
    }
    if (!latLngEquals(prev.currentLocation, next.currentLocation)) {
      return 'locationTick'
    }
    return 'none'
  }
  if (
    !latLngEquals(prev.destination, next.destination) ||
    prev.bottomSheetView !== next.bottomSheetView
  ) {
    return 'rebuildAndPan'
  }
  return 'none'
}
